import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import { SpinnerCircular } from "spinners-react"
import { mobNameKey } from "@/helpers/mobName"
import { MobDropGrid } from "@/modals/constructor/mobs/MobRewardModal/ui/MobDropGrid"
import { CurrencyIcon } from "@/ui/CurrencyIcon"
import styles from "./MobRewardView.module.scss"
import { IMobRewardViewProps } from "./types"

const MobRewardViewComponent: FC<IMobRewardViewProps> = ({
  status,
  typeCode,
  level,
  xp,
  drops,
  currencies,
  isNothing,
  onOk
}) => {
  const { t } = useTranslation(["mobs", "inventory", "catalog"])

  return (
    <div className={styles.MobRewardView}>
      <h2 className={styles.MobRewardView_title}>
        {t("reward.title", { ns: "mobs" })}
      </h2>
      {status === "loading" && (
        <div className={styles.MobRewardView_center}>
          <SpinnerCircular
            size={32}
            thickness={120}
            speed={120}
            color="#f0f0f0"
            secondaryColor="#3a3a3a"
          />
        </div>
      )}
      {status === "ready" && (
        <>
          <span className={styles.MobRewardView_name}>
            {t("reward.nameLevel", {
              ns: "mobs",
              name: t(mobNameKey(typeCode), {
                ns: "mobs",
                defaultValue: typeCode
              }),
              level
            })}
          </span>
          <span className={styles.MobRewardView_xp}>
            {t("reward.xp", { ns: "mobs", xp })}
          </span>
          {currencies.map((currency) => (
            <span
              key={currency.currencyCode}
              className={styles.MobRewardView_currency}
            >
              <CurrencyIcon
                size="small"
                iconUrl={currency.iconUrl}
                alt={t(`currency.${currency.currencyCode}.name`, {
                  ns: "catalog"
                })}
              />
              {t("reward.currency", {
                ns: "mobs",
                amount: currency.amountText,
                unit: t(`currency.${currency.currencyCode}.unit`, {
                  ns: "catalog",
                  count: currency.unitCount
                })
              })}
            </span>
          ))}
          {drops.length > 0 && <MobDropGrid drops={drops} />}
          {isNothing && (
            <span className={styles.MobRewardView_nothing}>
              {t("reward.nothing", { ns: "mobs" })}
            </span>
          )}
        </>
      )}
      <button type="button" className={styles.MobRewardView_ok} onClick={onOk}>
        {t("reward.ok", { ns: "mobs" })}
      </button>
    </div>
  )
}

export const MobRewardView = memo(MobRewardViewComponent)
